import { render } from "./headeradmin.vue?vue&type=template&id=6e36a239&scoped=true&ts=true"
import script from "./headeradmin.vue?vue&type=script&lang=ts"
export * from "./headeradmin.vue?vue&type=script&lang=ts"

import "./headeradmin.vue?vue&type=style&index=0&id=6e36a239&scoped=true&lang=scss"
import "./headeradmin.vue?vue&type=style&index=1&id=6e36a239&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e36a239"]])

export default __exports__